function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bot_l") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "258.59 9.16 258.33 9.81 398.98 374.11 258.59 9.16 258.59 9.16",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.59 9.16 258.33 9.81 398.98 374.11 258.59 9.16 258.59 9.16",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.63 0 433.32 328.72 316.63 0 316.63 0",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,330.45,669.41,685.88H635L400.23,374.11l33-43.66m.05-1.73L399,374.11l235.5,312.77h36.8l-238-358.16Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.54,467.21l87.06,14.32-123.83,153L746.59,644.9l74.95-177.69m-.62-1.11-76,180.31,40.48-11L910.46,480.82,820.92,466.1Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "778.55 0 811.79 365.68 820.92 466.1 778.55 0 778.55 0",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.63,1,819.9,465.94,744,646l0,.09,0,.1L732.94,701,705.07,718.4l-15.64-71,0-.12-.06-.12L480.9,230.3,452.43,1h325.2m.92-1H451.3l28.63,230.6,208.52,417L704.4,720l29.43-18.4,11-55.19,76-180.31L778.55,0Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.53,1l12.12,138.83-12.21,149L812.65,364.08,779.64,1H952.53m.92-1H778.55l33.24,365.68,141.6-76.21,12.27-149.64L953.45,0Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.36,1,916.76,457.3l37.61-167.61v-.14l12.24-149.42,61.22-107.75.11-.18,0-.22,2.82-31h28.56m1.36-1h-30.84L1027,31.89,965.66,139.83,953.39,289.47,910.46,480.82,1060.72,0Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.29,1,926.6,432.51,1061.45,1h18.84m1.42-1h-21L910.46,480.82,1081.71,0Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.79,1,1026,31.59l-59.64,105L954.54,1h74.25m1.09-1H953.45l12.21,139.83L1027,31.89,1029.88,0Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.41,1l28.53,229.72,0,.17.08.15L687.5,648l15.18,68.9-30.62-30.62-237.84-358L318.05,1H450.41m.89-1H316.63L433.32,328.72l238,358.16L704.4,720l-15.95-72.37-208.52-417L451.3,0Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.93,1,432.2,328.55l-32.93,43.52L259.67,9.16,262.94,1h53m.7-1H262.26l-3.67,9.16L399,374.11l34.34-45.39L316.63,0Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.78,1l-2.17,5.42L256.53,1h4.25m1.48-1h-7.19l3.52,9.16L262.26,0Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.89,1l3.51,9.17L397.81,373.86l-24.22,24.22L214.75,1h39.14m.69-1H213.27l160,399.86L399,374.11,258.33,9.81,254.58,0Z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.07 0 254.58 0 258.33 9.81 258.59 9.16 255.07 0 255.07 0",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    style: {
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotL);
export default __webpack_public_path__ + "static/media/bot_l.e2df42268bc8e6356a640959e45328bd.svg";
export { ForwardRef as ReactComponent };